import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';



import { getFieldNotesApi } from '@services/protocol';
import { setNotes } from '@state-mgmt/slices/notesSlice';
import { Note } from '@mytypes/protocol';
import { RootState } from '@state-mgmt/store';
import { setHistoricalVisitsProtocolId, setHistoricalVisitsTrialId } from '@state-mgmt/slices/visitSlice';

export const useGetFieldNotes = (fieldId: string | null, protocol_id: string | null, trial_id: string | null) => {

  const { trialId, protocolId, notes } = useSelector((state: RootState) => ({trialId: state.visit.historicalVisitsTrialId, protocolId: state.visit.historicalVisitsProtocolId, notes: state.notes.notes}));
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const dispatch = useDispatch();


  const updateNotes = useCallback((notes: Note[], protocolId: string | null, fieldId: string | null) => {
    dispatch(setNotes(notes));
    if (protocolId && fieldId) {
        localStorage.setItem(`field-notes-${protocolId}-${fieldId}`, JSON.stringify(notes));
    }
    
  }, [dispatch])


  const getFieldNotes = useCallback((fieldId: string | null, protocolId: string | null, trialId: string | null) => {
    let cancelled: boolean = false
    if (fieldId && protocolId && trialId) {
        updateNotes([], protocolId, fieldId)
        setIsLoading(true)
        getFieldNotesApi({ trialId, protocolId, fieldId }).then((notes) => {
            if (!cancelled) {
                updateNotes(notes?.notes || [], protocolId, fieldId)
            }
        }).catch((err) =>  {
            console.error('An error occurred fetching notes', err)
            if (cancelled) return 
            const notes = JSON.parse(localStorage.getItem(`field-notes-${protocolId}-${fieldId}`) || '[]');
            updateNotes(notes, protocolId, fieldId)
        }).finally(() => {setIsLoading(false)})
    } else {
        updateNotes([], null, null)
    }

    return () => {
        cancelled = true
    }
  }, [updateNotes])

  useEffect(() => {
    const cancelGetNotes = getFieldNotes(fieldId, protocolId, trialId)
    return ( ) => {
        cancelGetNotes()
    }
  }, [fieldId, protocolId, trialId, getFieldNotes])


  useEffect(() => {
      if (trial_id) {
        dispatch(setHistoricalVisitsTrialId(trial_id));
      } else {
        dispatch(setHistoricalVisitsTrialId(null));
      }
  
      if (protocol_id) {
        dispatch(setHistoricalVisitsProtocolId(protocol_id));
      } else {
        dispatch(setHistoricalVisitsProtocolId(null));
    }}, [trial_id, protocol_id])
    
  return [
     {
        data: notes || [],
        isLoading,
        getFieldNotes
     }
     

  ]

  
};
